// extracted by mini-css-extract-plugin
export default {"search":"SidebarSearch_search__2C5Ki","icon":"SidebarSearch_icon__R-QJ2","input":"SidebarSearch_input__PTicB"};